import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { MeResponse } from '../types/api';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api<MeResponse>('/me'),
  });
}
